import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p439691911520956416',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
